import { ControlType, FormFieldBase } from './form-field-base.model';

export class ChipsAutocompleteFormField extends FormFieldBase<string[]> {
  controlType: ControlType = 'chips-autocomplete';
}
